import React, { useState } from 'react';

import { useWindowSize } from '../hooks/useWindowSize';
import Title from '../components/Title/Title';

import Section from '../components/Modular/Section';
import { Card } from '../components/Card';
import { Link } from 'react-router-dom';
import DropDown from '../components/DropDown/DropDown';

import Button from '../components/Button';
import Unit from '../components/Modular/Unit';
import MicroUnit from '../components/Modular/MicroUnit';
import Layout from '../components/Modular/Layout';
import ServiceOffering from '../components/ServiceOffering/ServiceOffering';
import Calendar from '../components/Calendar/Calendar';
import TimeCarousel from '../components/TimeCarousel';
import ConsultationBookingForm from '../components/ConsultationBookingForm';
import MonthToggle from '../components/Calendar/MonthToggle';
import Nav from '../components/Nav/Nav';

import { useBookingLogic } from '../hooks/useBookingLogic/useBookingLogic';

export const CalendarPage = () => {
  const today = new Date();

  const windowSize = useWindowSize();
  const responsiveTitle = windowSize.width <= 798 ? 'center' : 'left';
  const responsiveWidth = windowSize.width <= 798 ? '3' : '9';
  const responsiveCalendarGrid =
    windowSize.width <= 798 ? 'appointment-grid-vertical' : 'appointment-grid';
  const buttonLayout = windowSize.width <= 798 ? 'grid' : 'flex';
  const layoutPlacement = windowSize.width <= 440 ? '' : 'center';

  const [navDropDown, setNavDropDown] = useState<boolean>(false);

  const {
    date,
    time,
    timeslotIsAvailable,
    availableTimeslots,
    loadingAvailableDates,
    availableDates,
    error,
    selectDay,
    selectTime,
    toggleMonth,
  } = useBookingLogic();

  console.log(date);

  const context = {
    section: {
      layout: 'grid',
      background: 'dark',
      justifyItems: 'center',
    },

    unit: {
      colSpan: '1',
      rowSpan: '1',
      justifyContent: 'center',
    },
  };

  const toggleNavMobile = () => {
    setNavDropDown((prev) => !prev);
    selectTime(null);
  };

  const handleCloseForm = () => {
    selectTime(null);
  };

  return (
    <Layout
      layout="grid"
      gridTemplate={responsiveCalendarGrid}
      gap="md"
      alignContent="center"
      justifyContent="center"
      background="dark"
      context={context}
    >
      <Section gridArea="1">
        {time && date.day && (
          <ConsultationBookingForm
            date={date}
            time={time}
            timeslotIsAvailable={timeslotIsAvailable}
            handleCloseForm={handleCloseForm}
          ></ConsultationBookingForm>
        )}
      </Section>
      <Section layout="grid" gridArea="2" gap="md">
        <Title responsiveTitle={responsiveTitle}></Title>

        <Section layout="grid" justifyContent="center" width={'9'}>
          {windowSize.width > 797 && (
            <MonthToggle date={date} onChange={toggleMonth}></MonthToggle>
          )}
          <Calendar
            selectDay={selectDay}
            loadingAvailableDates={loadingAvailableDates}
            date={date}
            availableDates={availableDates}
          />
          {windowSize.width < 797 && (
            <MonthToggle date={date} onChange={toggleMonth}></MonthToggle>
          )}
        </Section>

        <Section
          layout={buttonLayout}
          gridTemplate={`${buttonLayout === 'grid' ? 'vertical-4' : ''}`}
          gap="sm"
          paddingTop="md"
          paddingBottom="md"
          justifyContent="center"
          justifyItems="center"
          width={responsiveWidth}
        >
          {windowSize.width >= 798 && <Nav></Nav>}

          {windowSize.width <= 798 && (
            <DropDown
              navDropDown={navDropDown}
              toggleNavMobile={toggleNavMobile}
            ></DropDown>
          )}
        </Section>
      </Section>

      <Section gridArea="3">
        {date.day && (
          <TimeCarousel
            selectTime={selectTime}
            availableTimeslots={availableTimeslots}
          ></TimeCarousel>
        )}
      </Section>
    </Layout>
  );
};
